@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;600&display=swap');

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

$yellow: #fffaf2;
$background: #faf1e8;
$grey: #b7b7b7;
$brown: #e9d7ca;
$black: #474444;
$white: #fff;
$darkyellow: #fcd9c9;
$pink: #f1ded6;
$green: #25a710;
$orange: #ec6632;
$darkorange: #c84e18;

$border: 1px solid $darkyellow;
$greyBorder: 1px solid #e3e3e3;
$border-radius: 4px;
$box-shadow: 0px 4px 8px 0px #0000000a;
$box-shadow-hover: 0px 8px 16px 2px #0000000a;
$widgetBoxColor: 0px 2px 16px 0px #00000014;

@mixin hover {
  &:hover {
    transition: 0.1s all cubic-bezier(0.465, 0.183, 0.153, 0.946);
    filter: brightness(1.02);
    transform: scale(1.01);
    box-shadow: $box-shadow-hover;
  }
}

@mixin cartLength {
  position: relative;
  span {
    position: absolute;
    background: $white;
    border-radius: 100%;
    width: 24px;
    height: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 600;
    font-size: 13px;
    line-height: 11px;
    top: -6px;
    right: -12px;
  }
}

@mixin mobile {
  @media (max-width: 768px) {
    @content;
  }
}

@mixin desktop {
  @media (min-width: 769px) {
    @content;
  }
}

* {
  box-sizing: border-box;
}

:host {
  font-family: 'Inter', sans-serif;
  input[type='text'] {
    padding: 16px;
    width: 100%;
    font-size: 16px;
    border: 1px solid $darkyellow;
  }
  .mb-2 {
    margin-bottom: 32px;
  }
  button {
    color: $black;
  }
  form {
    display: flex;
    flex-direction: column;
    gap: 16px;
    position: relative;
    button {
      position: absolute;
      right: 0;
      top: -1rem;
    }
    img {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      pointer-events: none;
      &:first-of-type {
        left: 16px;
      }
      &:last-of-type {
        right: 16px;
      }
    }
    span {
      margin-top: -8px;
      color: $orange;
    }
    p {
      text-align: center;
    }
    p {
      margin: 0;
    }
    div {
      position: relative;
      label {
        pointer-events: none;
        position: absolute;
        left: 16px;
        top: 50%;
        transform: translateY(-50%);
        background: $white;
        padding: 4px;
        transition: 0.2s all cubic-bezier(0.465, 0.183, 0.153, 0.946);
      }
      input {
        padding: 16px;
        width: 100%;
        font-size: 16px;
        border: 1px solid $darkyellow;
      }
      input:focus ~ label,
      .input_active ~ label {
        top: 0;
        transform: translateY(-50%);
        background: linear-gradient(180deg, $background 50%, $white 50%);
      }
    }
    select {
      padding: 0.75rem 1rem;
      width: 100%;
    }
  }
  h1 {
    font-size: 24px;
    font-weight: 400;
    line-height: 32px;
    letter-spacing: -3%;
    text-align: left;
    margin: 0 0 8px;
  }
  h2 {
    margin: 0 0 24px;
    font-weight: 700;
    font-size: 20px;
    line-height: 28px;
    letter-spacing: -3%;
  }
  p {
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: -3%;
  }
  .hemfixarna {
    width: 100%;
    &_source {
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      img {
        width: 20px;
      }
      &--pw {
        max-width: 300px !important;
        input[type='password'] {
          padding: 0.5rem;
        }
        form {
          display: flex;
          flex-direction: column;
          gap: 1rem;
        }
      }
    }
    &_contact {
      display: flex;
      gap: 16px;
      a {
        display: flex;
        align-items: center;
        gap: 8px;
        color: $black;
        text-decoration: none;
        font-weight: 600;
        font-size: 13px;
        &:hover {
          text-decoration: underline;
        }
      }
      &--horizontal {
        span {
          display: none;
        }
        @include desktop {
          span {
            display: initial;
          }
        }
      }
    }
    &_painting {
      > h2,
      p {
        text-align: center;
        padding: 0 16px;
      }
      > h2 {
        margin: 0 0 8px;
      }
      opacity: 0;
      padding: 0 1rem;
      animation: fadeIn 0.5s forwards 0.3s;
    }
    &_partnerlogo {
      max-height: 50px;
      min-height: 45px;
      object-fit: contain;
      max-width: 150px;
      @include desktop {
        max-width: 200px;
      }
    }
    &_nav {
      position: absolute;
      top: 0;
      width: 100dvw;
      left: 0;
      height: 80px;
      z-index: 9999;

      &--links {
        display: none !important;
        @include desktop {
          display: flex !important;
        }
        a {
          color: $orange;
          text-decoration: none;
          border: 1px solid rgba($color: $white, $alpha: 0.3);
          border-radius: 56px;
          padding: 8px 32px;
          text-transform: capitalize;
        }
      }
      > div {
        position: relative;
        overflow: hidden;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 16px;
        @include desktop {
          padding: 0 32px;
        }
        > div {
          display: flex;
          gap: 32px;
          justify-content: space-between;
        }

        > img {
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          z-index: -1;
        }
      }
      a {
        text-decoration: none;
      }
      p {
        color: $black;
      }
      p.with-bg {
        color: $white;
      }
    }
    &_standalone {
      .hemfixarna {
        &_backdrop {
          background: $yellow;
          opacity: 1;
        }
        &_modal {
          top: 80px;
          transform: translateX(-50%);
          border: none;
          height: calc(100dvh - 80px);
          opacity: 0;
          &--open {
            opacity: 1;
          }
        }
      }
    }
    .switch {
      position: relative;
      display: inline-block;
      width: 40px;
      height: 20px;
    }

    /* Hide default HTML checkbox */
    .switch input {
      opacity: 0;
      width: 0;
      height: 0;
    }

    /* The slider */
    .slider {
      position: absolute;
      cursor: pointer;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: #ccc;
      -webkit-transition: 0.4s;
      transition: 0.4s;
      border-radius: 34px;
    }

    .slider:before {
      position: absolute;
      content: '';
      height: 18px;
      width: 18px;
      left: 2px;
      bottom: 1px;
      background-color: white;
      -webkit-transition: 0.4s;
      transition: 0.4s;
      border-radius: 50%;
    }

    input:checked + .slider {
      background-color: $darkyellow;
    }

    input:focus + .slider {
      box-shadow: 0 0 1px $darkyellow;
    }

    input:checked + .slider:before {
      -webkit-transform: translateX(18px);
      -ms-transform: translateX(18px);
      transform: translateX(18px);
      background: $orange;
    }

    &_maleribox {
      background: $white;
      box-shadow: $box-shadow;
      width: 100%;
      min-height: 132px;
      padding: 24px;
      display: flex;
      align-items: center;
      gap: 24px;
      text-align: left;
      @include hover;
    }

    &_checkbox {
      display: grid;
      grid-template-columns: 40px auto;
      font-size: 16px;
      font-weight: 400;
      line-height: 24px;
      letter-spacing: -3%;
      > span {
        transform: translateY(6px);
      }
      span,
      span p {
        color: $black;
        font-size: 14px;
      }
      p {
        text-align: left;
      }
    }

    &_info {
      display: flex;
      flex-direction: column;
      gap: 24px;
      padding: 32px;
      box-shadow: $box-shadow;
      border-radius: $border-radius;
      border: $border;
      h2 {
        margin: 0;
      }
      @include desktop {
        position: sticky;
        top: 0;
      }
    }

    &_infomodal {
      position: absolute;
      top: 40%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 100%;
      max-width: 80%;
      background: $yellow;
      border: $border;
      padding: 32px;
      z-index: 99;
      border-radius: $border-radius;
      box-shadow: $box-shadow;
      display: flex;
      flex-direction: column;
      gap: 16px;
      p,
      h4 {
        margin: 0;
      }
      button {
        background: $orange;
        color: $white;
        border-radius: 60px;
        font-size: 16px;
        padding: 8px 16px;
      }
    }

    &_addressinfo {
      padding: 16px 16px 64px;
      border: $border;
      position: relative;
      margin-bottom: 32px;
      display: grid;
      grid-template-columns: 1fr;
      gap: 8px;
      @include desktop {
        grid-template-columns: 1fr 1fr;
      }
      button {
        position: absolute;
        bottom: 16px;
        right: 16px;
        font-weight: 500;
        text-underline-offset: 2px;
        text-decoration: underline;
      }
    }

    &_part {
      background: $white;
      box-shadow: $box-shadow;
      display: grid;
      padding: 16px;
      grid-template-columns: auto 75px;
    }
    &_counter {
      display: flex;
      align-items: center;
      span {
        padding: 0 8px;
      }
      img {
        cursor: pointer;
        &:not(.disabled) {
          @include hover;
        }
      }
    }
    &_description {
      display: grid;
      gap: 16px;
      ul {
        list-style: disc;
        padding-right: 12px;
        transform: translateX(12px);
      }
      &--hidden {
        max-height: 140px;
        overflow: hidden;
        position: relative;
        cursor: pointer;
        &::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          height: 128px;
          background: linear-gradient(180deg, rgba(255, 253, 250, 0), rgba(255, 253, 250, 0.46) 50%, $background);
        }
      }
    }
    &_terms {
      font-size: 14px;
      a {
        color: inherit;
      }
    }
    &_logo {
      height: 64px;
    }
    &_box {
      padding: 16px;
      display: flex;
      align-items: center;
      width: 100%;
      box-sizing: border-box;
      border-radius: 4px;
      gap: 16px 8px;
      border-radius: 4px;
      gap: 16px 8px;
      p,
      span {
        font-size: 15px;
      }
      .underline {
        text-decoration: underline;
        text-underline-offset: 2px;
      }
      .pointer {
        cursor: pointer;
      }
      .p-s {
        font-size: 12px;
      }
      > div {
        display: grid;
        gap: 8px;
      }
      &--standard {
        background: $yellow;
        border: $border;
      }
      &--alternative,
      &--alternative_2,
      &--alternative_3 {
        background: transparent;
        border: $greyBorder;
      }
      &--alternative_2,
      &--alternative_3 {
        box-shadow: $widgetBoxColor;
      }
      &--alternative_3 {
        justify-content: center;
      }
    }
    &_altbtn {
      display: flex !important;
      flex-direction: column;
      gap: 8px;
      align-items: center;
      margin-left: auto;
    }
    &_btn {
      margin-left: auto;
    }
    &_btn,
    &_buy,
    input[type='submit'] {
      border: none;
      border-radius: 60px;
      font-weight: 600;
      letter-spacing: 0.5px;
      line-height: 20px;
      box-shadow: $box-shadow;
      &:not(.disabled) {
        @include hover;
      }
    }
    div:has(> input[type='submit']) {
      position: relative;
      input {
        cursor: pointer;
      }
      img {
        display: none;
      }
    }
    .loading {
      cursor: default;
      opacity: 0.6;
      > img {
        display: initial !important;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
    &_btn {
      font-size: 14px;
      background: $darkorange;
      color: $white;
      padding: 16px 24px;
      white-space: nowrap;
      @include cartLength;
      span {
        background: $green;
        color: $white;
        right: 0 !important;
      }
    }
    &_buy,
    input[type='submit'] {
      font-size: 21px;
      background: $green;
      color: $white;
      padding: 16px 24px;
    }
    .disabled {
      opacity: 0.5;
      cursor: default;
    }
    &_modal {
      position: fixed;
      background: $background;
      border: $border;
      border-radius: $border-radius;
      top: 50%;
      left: 50%;
      z-index: 1000;
      transition: 0.1s all cubic-bezier(0.465, 0.183, 0.153, 0.946);
      transform: translate(-50%, -50%) scale(0.7);
      opacity: 0;
      height: 92%;
      width: 92%;
      max-width: 920px;
      display: flex;
      flex-direction: column;
      gap: 8px;
      &--open {
        opacity: 1;
        transform: translate(-50%, -50%) scale(1);
      }
    }
    &_backdrop {
      z-index: 999;
      position: fixed;
      background: $black;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      opacity: 0;
      transition:
        transform 0.1s cubic-bezier(0.465, 0.183, 0.153, 0.946),
        opacity 0.1s cubic-bezier(0.465, 0.183, 0.153, 0.946);
      &--open {
        opacity: 0.3;
      }
    }
    &_order {
      position: absolute;
      top: -1px;
      left: -1px;
      right: -1px;
      bottom: -1px;
      background-repeat: no-repeat !important;
      background-size: cover !important;
      background-position: center !important;
      display: grid;
      grid-template-columns: 1fr 1fr;
      padding: 48px 32px 64px;
      @include mobile {
        grid-template-columns: 1fr;
        grid-template-rows: 0 auto;
      }
      > div:last-of-type {
        background: $yellow;
        padding: 32px;
        display: flex;
        flex-direction: column;
        max-height: 100%;
        overflow: auto;
      }
      img {
        cursor: pointer;
      }
      button {
        margin: 16px 0;
        padding: 0;
        text-decoration: underline;
        text-underline-offset: 2px;
        font-size: 14px;
        font-weight: 600;
      }
    }
    &_cart {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 32px;
      @include mobile {
        grid-template-columns: 1fr;
        gap: 0;
      }
      &--right,
      &--left {
        h2 {
          display: flex;
          align-items: center;
          img {
            margin-top: 3.2px;
          }
        }
      }
      &--left {
        h2 {
          button {
            @include desktop {
              display: none;
            }
          }
        }
      }
      &--right {
        h2 {
          button {
            @include mobile {
              display: none;
            }
          }
        }
      }
      &--startfee {
        display: flex;
        justify-content: space-between;
      }
      &--rutrot {
        display: flex;
        justify-content: space-between;
        div {
          display: flex;
          gap: 16px;
          align-items: center;
        }
      }
      &--additional {
        display: flex;
        flex-direction: column;
        gap: 16px;
        padding: 16px;
        border-top: $border;
        p {
          font-size: 14px;
          position: relative;
          strong {
            text-decoration: underline;
            text-underline-offset: 2px;
            cursor: pointer;
          }
          img {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            right: -20px;
            cursor: pointer;
          }
        }
      }
      &--price {
        border-top: $border;
        h3 {
          margin: 0;
        }
        padding: 16px;
        display: flex;
        justify-content: space-between;
      }
      &--item {
        display: flex;
        flex-direction: column;
        gap: 8px;
        padding: 16px 0;
        border-top: $border;
        span {
          font-size: 12px;
        }
        > div {
          display: flex;
          justify-content: space-between;
          > div {
            display: flex;
            align-items: center;
            gap: 16px;
          }
          button {
            color: $orange;
          }
        }
      }
      &--group {
        border-radius: 16px;
        background: #fefaf6;
        margin-bottom: 16px;
        padding: 10px 20px;
        ul {
          li {
            &:first-of-type {
              border-top: 0;
            }
          }
        }
      }
    }
    &_categories {
      &--wrapper {
        gap: 32px;
        display: grid;
        grid-template-columns: 1fr 1fr;
        @include mobile {
          grid-template-columns: 1fr;
        }
      }
      display: flex;
      flex-direction: column;
      gap: 24px;
      li {
        position: relative;
        background: $white;
        border-radius: $border-radius;
        min-height: 132px;
        padding: 24px;
        box-shadow: $box-shadow;
        display: flex;
        align-items: center;
        gap: 24px;
        cursor: pointer;
        @include hover;
        > button {
          height: 100%;
          width: 100%;
        }
        .price {
          font-weight: 700;
        }
      }
    }
    &_content {
      height: 100%;
      overflow: auto;
      padding: 0 32px 64px;
      &--5 {
        padding-top: 16px;
      }
      &--painting {
        padding: 0;
        overflow: initial;
      }
    }
    &_crumbs {
      position: relative;
      padding: 16px 24px;
      border-bottom: $border;
      display: flex;
      justify-content: space-between;
      &--back {
        padding: 16px 24px 8px;
        display: flex;
        align-items: center;
        gap: 8px;
        box-shadow: none !important;
        @include hover;
      }
      img {
        cursor: pointer;
      }
      .close {
        position: absolute;
        right: -16px;
        top: -16px;
        z-index: 9;
        -webkit-transform: translate3d(0, 0, 0);
      }
      .cart {
        display: flex;
        padding-left: 16px;
        img {
          cursor: inherit;
        }
        @include cartLength;
        &_active {
          cursor: pointer;
          span {
            background: $green;
            color: $white;
          }
        }
      }
      &--links {
        display: flex;
        align-items: center;
        gap: 16px;
        overflow: auto;
        @include desktop {
          &::-webkit-scrollbar {
            display: none;
          }

          &::-webkit-scrollbar-button {
            display: none;
          }
          -ms-overflow-style: none;
        }
      }
      &--right {
        display: flex;
        align-items: center;
      }
      button {
        white-space: nowrap;
        background: $pink;
        border-radius: 64px;
        padding: 12px 16px;
        font-size: 12px;
        font-weight: 600;
        letter-spacing: 0.3px;
        box-shadow: none !important;
        &:not(.active) {
          @include hover;
        }
        @include mobile {
          display: none;
        }
      }
      .active {
        background: $yellow;
        cursor: default;
        // border: 1px solid $pink;
      }
    }
    &_features {
      gap: 12px !important;
      li {
        display: flex;
        gap: 16px;
        align-items: center;
      }
    }
    &_address {
      margin-bottom: 16px;
    }
    &_product {
      display: grid;
      gap: 16px;
      &--link {
        font-weight: 700;
        color: $black;
        text-underline-offset: 4px;
      }
      &--left {
        gap: 32px;
      }
      &--right {
        gap: 32px;
      }
      &--price {
        margin-top: 4px;
        font-weight: 700;
      }
      &--total {
        text-align: center;
        margin: -16px 0;
        font-size: 21px;
        line-height: 28px;
      }
      &--item {
        background: $white;
        padding: 16px;
        display: grid;
        grid-template-columns: auto 75px;
        box-shadow: $box-shadow;
      }
      &--grid {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 32px;
        @include mobile {
          grid-template-columns: 1fr;
        }
        > div {
          display: flex;
          flex-direction: column;
        }
        ul {
          display: flex;
          flex-direction: column;
          gap: 4px;
        }
      }

      .generate-pdf-button {
        border-radius: 88px;
        background: -o-linear-gradient(303deg, #EC873E 0%, #E5421E 100%);
        background: linear-gradient(147deg, #EC873E 0%, #E5421E 100%);
        color: #fff;
        text-align: center;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: 24px;
        padding: 12px 25px;
        border: 0;
        text-decoration: none;
        max-width: 300px;
        cursor: pointer;
      }

      p {
        margin: 0;
      }
      &--top {
        img {
          object-fit: contain;
        }
        > div {
          width: 100%;
          h1 {
            max-width: 80%;
            @include mobile {
              max-width: 100%;
            }
          }
        }
        display: flex;
        gap: 32px;
        h4 {
          margin-bottom: 8px;
        }
      }
    }
  }
  h5,
  p {
    margin: 0;
  }
  input[type='submit'] {
    cursor: pointer;
  }
  input[type='date'] ~ label {
    left: 56px;
  }
  input[type='date'] {
    border: 1px solid $darkyellow;
    padding-left: 64px;
  }
  input[type='checkbox'] {
    height: 18px;
    width: 18px;
    border: $border;
  }
  input[type='checkbox']:checked {
    background: red;
  }
  input[type='date']::-webkit-calendar-picker-indicator {
    background: transparent;
    bottom: 0;
    color: transparent;
    cursor: pointer;
    height: auto;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    width: auto;
  }
  button,
  a {
    cursor: pointer;
    background: none;
    border: none;
  }
  ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }
}
